module.exports = __webpack_public_path__ + "static/img/222.3bdd68e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/222.jpg
// module id = rF8A
// module chunks = 0